export enum OrganisationRoutesEnum {
  whiteLabelingPreview = 'white-labeling-preview',
}
